/**
 * Thai dictionary, split by area so each part of the game owns its strings.
 * Keys are the exact English source text (including {placeholders}).
 */
import { CONTENT } from './content';
import { COMMON } from './common';
import { NOTEBOOK } from './notebook';
import { BATTLE } from './battle';
import { CREATOR } from './creator';
import { MULTIPLAYER } from './multiplayer';
import { SCRAPBOOK } from './scrapbook';
import { FAMILY } from './family';
import { CONTEST } from './contest';
import { DAILY } from './daily';
import { COMMUNITY } from './community';
import { ACCOUNT } from './account';
import { SHOP } from './shop';
import { SEASON1 } from './season1';
import { SOCIAL } from './social';
import { CLASSROOM } from './classroom';
import { FORTUNE } from './fortune';
import { GACHA } from './gacha';

export const TH: Record<string, string> = { ...CONTENT, ...COMMON, ...NOTEBOOK, ...BATTLE, ...CREATOR, ...MULTIPLAYER, ...SCRAPBOOK, ...FAMILY, ...CONTEST, ...DAILY, ...COMMUNITY, ...ACCOUNT, ...SHOP, ...SEASON1, ...SOCIAL, ...CLASSROOM, ...FORTUNE, ...GACHA };
